const Form105TC = {
    stepName: {
        importantNotes: "重要提示",
        partA: "選擇文件",
        confirmation: "確認",
    },
    label: {
        applicationPurpose: "提交文件",
        sectionName: "表格名稱",
        contactPerson: "是次提交的聯絡人",
        telephoneNo: "聯絡人的電話號碼",
        emailAddress: "聯絡人的電郵地址",
        uploadFiles: "選擇提交的檔案",
        reoCode: "提交副本至區域教育服務處",
        contactInformation:
            "有關是次文件提交事宜，請致電 {{sectionTel}} 與 {{sectionName}} 聯絡。",
        contactInformationNotTel:
            "有關是次文件提交事宜，請與 {{sectionName}} 聯絡。",
        scrnOrOrg: "學校 / 機構",
        submittedTo: "請選擇：",
        conditionsCheck:
            "我確認將上述{{uploadFilesLength}}個檔案提交到{{sectionName}}。",
        helpdesk:
            "有關系統支援，請致電 2694 5892 與「教育局電子表格遞交系統」求助台聯絡。",
        logout: "尚未登錄，不能提交這張form。",
    },
    errorMsg: {
        pdfSignRequired: "請簽署PDF。",
        exceedTotalSize: "所有檔案總共大小最大為45MB。",
    },
    AttachmentInstruction1: "可接受的檔案類型：{{types}}",
    AttachmentInstruction2: "每個檔案最大為{{size}}MB。",
    AttachmentInstruction3: "檔案名稱最長為{{length}}個字元。",
    AttachmentInstruction4:
        "如需增加更多檔案（最多{{files}}個），請使用“增加”按鈕。",
    AttachmentInstruction5: "所有檔案總共大小最大為45MB。",
};

export default Form105TC;
